import { CultureInfo } from '../culture-info.model';
import { CultureInfoFr } from './fr';

/**
 * @ignore
 */
export const CultureInfoFrFR: CultureInfo = {
  name: 'fr-FR',
  displayName: 'French (France)',
  iso3LanguageCode: 'fra',
  iso2LanguageCode: 'fr',
  ietfLanguageTag: 'fr-FR',
  parent: CultureInfoFr
};
